<script>
import Layout from "../../layouts/main";
import apigeneric from "@/helpers/apigeneric";
import appConfig from "@/app.config";
import Slider from "../components/slider";
import News from "../components/news";
import Notices from "../components/notices";
import Activities from "../components/activities";
import Imagelinks from "../components/imagelinks";
import Links from "../components/links";

export default {
  props: {
    WebSite: [String, Object],
  },
  mixins: [ apigeneric],
  page: {
    title: process.env.VUE_APP_NAME,
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Slider,
    News,
    Notices,
    Activities,
    Imagelinks,
    Links,
  },
  data() {
    return {
      title: this.$t("StrAnasayfa.Title"),
      items: [
        {
          text: this.$t("StrAnasayfa.Title"),
          active: true,
        },
      ],
      LinksData: {},
      fetchingStats: true,
    };
  },
  methods: {
    Get() {

      let Page = {
      PageNumber: "1",
      PageSize: "9999",
      PageDataSize: "1", 
    };  
        this.ActionsFilterGet({
        Service: "Links",
        Page: Page,
        Filter:"&Linkcategory=2&Websiteid="+window.$cookies.get("ecampuswebsite"),
      }).then((res) => {
        this.LinksData = res.Data; 
        for (let i = 0; i < this.LinksData.length; i++) {
          this.LinksData[i].i = i;
}
      });

    },
  },
  created() {},
};
</script>

<template>
  <Layout>
    <Slider />
    <template v-for="(element, index) in JSON.parse(WebSite.Sitejson)">
      <div :key="index" :class="element.col" class="mb-2">
        <div class="row">
          <template v-for="(child, childindex) in element.child">
            <div :key="childindex" :class="child.col">
           
              <News v-if="child.name == 'Haberler'" />
              <Notices v-if="child.name == 'Duyurular'" />
              <Activities v-if="child.name == 'Etkinlikler' || child.name == 'Etkinlik' || child.name == 'Activities'" />
              <Imagelinks v-if="child.name == 'Resimli Hızlı Erişim Bağlantıları'"/>
              <links v-if="child.name == 'Hızlı Erişim Bağlantıları'" />
            </div>
          </template>
        </div>
      </div>
    </template>
  </Layout>
</template>
